const LOCAL = "http://localhost:4049"
const PROD = "https://node-mapp.mappsistemas.com"

export function urlMappRequest() {
	if (typeof window === "undefined") return PROD
	const host = window.location.hostname
	if (host === "localhost" || host === "127.0.0.1") return LOCAL
	return PROD
}

let cache = { dominio: "", at: 0, cfg: null }

export async function buscarMapaProfissional(dominio) {
	const id = String(dominio || "").trim()
	if (!id) return { mapa: false, chave: "" }
	if (cache.cfg && cache.dominio === id && Date.now() - cache.at < 15000) return cache.cfg
	const controle = new AbortController()
	const timer = setTimeout(() => controle.abort(), 4000)
	try {
		const qs = new URLSearchParams({ dominio: id })
		const resp = await fetch(`${urlMappRequest()}/api/v1/app-cliente/google-maps/mapa-profissional?${qs}`, {
			signal: controle.signal,
			headers: { "X-Domain": id }
		})
		const json = await resp.json()
		const dados = json?.dados || {}
		const cfg = {
			mapa: Boolean(dados.mapa) && Boolean(dados.chave),
			chave: dados.mapa ? String(dados.chave || "") : ""
		}
		cache = { dominio: id, at: Date.now(), cfg }
		return cfg
	} catch {
		return { mapa: false, chave: "" }
	} finally {
		clearTimeout(timer)
	}
}

let sdkPromise = null
let sdkChave = ""

export function carregarGoogleMapsSdk(chave) {
	if (typeof window === "undefined" || !chave) return Promise.resolve(false)
	if (window.google?.maps && sdkChave === chave) return Promise.resolve(true)
	if (sdkPromise && sdkChave === chave) return sdkPromise
	sdkChave = chave
	sdkPromise = new Promise((resolve) => {
		const pronto = () => resolve(Boolean(window.google?.maps))
		const existing = document.querySelector("script[data-google-maps-prof]")
		if (existing) {
			if (window.google?.maps) pronto()
			else {
				existing.addEventListener("load", pronto)
				existing.addEventListener("error", () => resolve(false))
			}
			return
		}
		const s = document.createElement("script")
		s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(chave)}&language=pt-BR&region=BR`
		s.async = true
		s.defer = true
		s.setAttribute("data-google-maps-prof", "1")
		s.onload = pronto
		s.onerror = () => resolve(false)
		document.head.appendChild(s)
	})
	return sdkPromise
}

export function registrarUsoMapaProfissional(dominio) {
	const id = String(dominio || "").trim()
	if (!id) return
	fetch(`${urlMappRequest()}/api/v1/app-cliente/google-maps/uso`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			"X-Domain": id
		},
		body: JSON.stringify({
			sku: "mapsJavascript",
			lugar: "appProfissional",
			dominio: id
		})
	}).catch(() => {})
}

export function mapaGoogleRecusado(el) {
	if (!el) return false
	if (el.querySelector(".gm-err-container, .gm-err-message, .gm-err-title")) return true
	return /Algo deu errado|não carregou o Google Maps|didn.?t load Google Maps/i.test(el.innerText || "")
}
